import { render } from "./ExpenseCategoryReport.vue?vue&type=template&id=4c5cc868"
import script from "./ExpenseCategoryReport.vue?vue&type=script&lang=js"
export * from "./ExpenseCategoryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__